module.exports = __webpack_public_path__ + "static/media/Screenshot3.cd39c382.png";